<template>
  <a-modal
    :open="visible"
    wrap-class-name="xmov-form-modal"
    width="635px"
    title="绑定手机号"
    :mask-closable="false"
    :closable="false"
    centered
    :after-close="onAfterClose"
    @cancel="onCancel"
  >
    <a-form
      ref="formRef"
      :model="formState"
      hide-required-mark
      v-bind="formLayout"
      class="bind-phone-modal__form"
    >
      <a-form-item
        v-if="!isGlobalVersion()"
        name="mobile"
        label="手机号"
        :rules="[{ required: true, validator: validatePhone, trigger: 'blur' }]"
      >
        <a-input
          v-model:value="formState.mobile"
          size="large"
          :placeholder="$t('qing-shu-ru-shou-ji-hao')"
        />
      </a-form-item>

      <a-form-item
        name="sms_code"
        label="验证码"
        :rules="[
          {
            required: true,
            message: $t('qing-shu-ru-yan-zheng-ma'),
            trigger: 'blur',
          },
        ]"
      >
        <XCaptchaInput
          v-model:value="formState.sms_code"
          size="large"
          :placeholder="$t('qing-shu-ru-yan-zheng-ma')"
          :data="formState.mobile"
        />
      </a-form-item>
    </a-form>
    <template #footer>
      <div class="bind-phone-modal__footer">
        <a-button
          type="primary"
          :disabled="!isDisabled"
          class="bind-phone-modal__footer-button"
          @click="onSubmit"
        >
          {{ $t('que-ding') }}
        </a-button>
      </div>
    </template>
  </a-modal>
</template>

<script lang="ts" setup>
import { validatePhone } from '@/utils/form';
import { message } from '@rendora/common/composables/message';
import type { FormInstance } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';
import {
  postWechatOfficialAccountCreate,
  type IWechatOfficialAccountCreateConfig,
} from '~/api/module/open-login';

const { t: $t } = useI18n();
const props = defineProps<{ ticketId: string }>();

const visible = ref(false);
const emits = defineEmits(['cancel', 'reload', 'ok']);

const userInfo = useUserInfo();
const formLayout = {
  wrapperCol: { span: 24 },
};
const formRef = ref<FormInstance>();
const formState = reactive<Omit<IWechatOfficialAccountCreateConfig, 'ticket_id'>>({
  mobile: '',
  sms_code: '',
});

const isDisabled = computed(() => formState.mobile && formState.sms_code);

const onAfterClose = () => {
  formState.mobile = '';
  formState.sms_code = '';
  formRef.value?.clearValidate?.();
};

const toggleShow = () => {
  visible.value = !visible.value;
};

const onCancel = () => {
  visible.value = false;
};

const onSubmit = async () => {
  try {
    const res = await formRef.value?.validateFields();

    if (res?.mobile === userInfo?.value?.phone_number) {
      message.warning($t('qing-shu-ru-xin-de-shou-ji-hao'));
      return;
    }
    const result = await postWechatOfficialAccountCreate({
      mobile: formState.mobile,
      sms_code: formState.sms_code,
      ticket_id: props.ticketId,
    });

    if (!result.code) {
      message.success('绑定手机成功');
      emits('ok', result.data);
      onCancel();
    }
  } catch (error) {
    // 捕获一下错误，防止正常的 crash
  }
};

defineExpose({
  toggle: toggleShow,
});
</script>

<style lang="scss" scoped>
@use '@rendora/design/styles/mixins.scss' as *;

.bind-phone-modal__form {
  width: 334px;
  margin: 40px auto;
}

.bind-phone-modal__footer {
  text-align: center;
}

.bind-phone-modal__footer-button {
  width: 390px;
}
</style>
